module.exports = __webpack_public_path__ + "static/img/3.8ed2205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/3.png
// module id = bPMq
// module chunks = 0